<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="halftitle"></a><a id="page_i">WOMEN, WORK &amp; THE ART <em>of</em> SAVOIR FAIRE</a></h1><a id="page_i">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm1_half.vue?cdd6139e